import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchStartupDetails, getdownloadLink } from '../../../networking/network'
import { useAppSelector } from '../../../store/hooks'
import UserCommentsListView from './UserCommentsListView'
import UserScoreListView from './UserScoreListView'

interface Props {

}

const UserScoresContainer = (props: Props) => {
  const { id } = useParams()

  const accessToken = useAppSelector(state => state.user.token)
  const [logoLink, setLogoLink] = useState<string | undefined>(undefined)
  const [companyName, setCompanyName] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!accessToken || !id) {
      return
    }

    const fetchStartup = async () => {
      const startup = await fetchStartupDetails(accessToken, id)
      if (startup.logoUrl !== undefined) {
        const logoURL = await getdownloadLink(accessToken, startup.logoUrl)
        setLogoLink(logoURL)
        setCompanyName(startup.name)
      } else {
        setCompanyName(startup.name)
      }
    }

    fetchStartup()
  }, [])

  return (
    <Box display='flex' flexDirection='column' sx={{
      padding: '16px'
    }}>
      <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-around' sx={{
        height: '70px',
        backgroundColor: 'white',
        borderRadius: '16px'
      }}>
        {logoLink !== undefined &&
          <img src={logoLink} alt={companyName} style={{
            height: '60px'
          }} />
        }
        {logoLink === undefined && companyName !== undefined &&
          <Typography variant='h3'>
            {companyName}
          </Typography>
        }
      </Box>
      <Box display='flex' flexDirection='row'>
        <UserScoreListView />
        <UserCommentsListView />
      </Box>
    </Box>
  )
}

export default UserScoresContainer
